/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import React from 'react';
import type { FC } from 'react';
import type { FilledTextFieldProps } from '@mui/material';
import { alpha, TextField } from '@mui/material';
import type { SxProps } from '@mui/system';

interface InputFieldProps extends Omit<FilledTextFieldProps, 'variant'> {
  InputProps?: Record<string, any>;
  sx?: SxProps;
}

export const InputField: FC<InputFieldProps> = React.forwardRef((props: InputFieldProps, ref: any) => {
  const { InputProps, sx, inputProps, ...other } = props;

  return (
    <TextField
      inputProps={{
        ...inputProps,
        sx: {
          alignItems: 'center',
          display: 'flex',
          fontSize: 14,
          height: 'unset',
          lineHeight: 1.6,
          px: 1,
          py: 0.4,
          '&.MuiInputBase-inputAdornedStart': {
            pl: 0,
          },
        },
      }}
      variant="filled"
      InputLabelProps={{
        shrink: true,
        sx: {
          color: 'text.primary',
          fontSize: 14,
          fontWeight: 500,
          mb: 0.5,
          position: 'relative',
          transform: 'none',
          zIndex: 0,
        },
      }}
      sx={{
        '& .MuiFilledInput-root': {
          backgroundColor: 'background.paper',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: 'neutral.300',
          borderRadius: 1,
          boxShadow: '0px 1px 2px 0px rgba(9, 30, 66, 0.08)',
          overflow: 'hidden',
          p: 0,
          transition: (theme) =>
            theme.transitions.create(['border-color', 'box-shadow']),
          '&:before': {
            borderBottom: 0,
          },
          '&:hover': {
            backgroundColor: 'background.paper',
          },
          '&.Mui-focused': {
            backgroundColor: 'background.paper',
            boxShadow: (theme) =>
              `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
          },
          '&.Mui-disabled': {
            backgroundColor: 'action.disabledBackground',
            boxShadow: 'none',
            borderColor: alpha('#D6DBE1', 0.5),
          },
          '.MuiInputAdornment-root.MuiInputAdornment-positionStart.MuiInputAdornment-root:not(.MuiInputAdornment-hiddenLabel)':
          {
            mt: 0,
            ml: 1.5,
          },
        },
        ...sx,
      }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      InputProps={{
        ...InputProps,
        disableUnderline: true,
      }}
      {...other}
      fullWidth
    />
  );
});
